export var PARAM_EMPTY_VALUE = '_';
export var PARAM_VALUE = 'value';